<template>
  <div :class="`pergunta-container ${classeValidacao}`" :id="`pergunta_id_${pergunta.perguntaId}_sessao_pergunta_id_${pergunta.sessaoFormularioPerguntaId}`">
        <component
          :is="componentePergunta"
          :pergunta="pergunta"
           />

  </div>
</template>

<script>
import RespostaTipoRadioButton from './RepostaTipoRadioButton'
import RespostaTipoRadioButtonHorizontal from './RespostaTipoRadioButtonHorizontal'
import RespostaTipoCheckboxVertical from './RespostaTipoCheckboxVertical'
import RespostaTipoTextInputCPF from './RespostaTipoCpf'
import RespostaTipoTextInputNumeroDecimal from './RespostaTipoNumeroDecimal'
import RespostaTipoTextInputPeso from './RespostaTipoPeso'
import RespostaTipoTextInputAltura from './RespostaTipoAltura'
import RespostaTipoTextInputNumeroInteiro from './RespostaTipoNumeroInteiro'
import RespostaTipoInputSelect from './PerguntaTipoSelect'
import RespostaTipoInputSelect2 from './PerguntaTipoSelect2'
import RespostaTipoInputText from './RespostaTipoTexto'

import TipoResposta from '../../config/TipoResposta.js'

export default {
  name: 'comp-pergunta',
  components:
  {
    RespostaTipoRadioButton,
    RespostaTipoRadioButtonHorizontal,
    RespostaTipoCheckboxVertical,
    RespostaTipoTextInputCPF
  },
  data () {
    return {
      tipoReposta: null,
      componentePergunta: ''
    }
  },
  computed:{
    formulario:function(){
      return this.$store.state.formulario;
    },
    classeValidacao(){
      const {verificacaoRespostaHabilitado} = this.$store.state;

      if(verificacaoRespostaHabilitado){
          const {perguntasNaoRespondidas} = this.$store.getters;
          const perguntaNaoRespondida = perguntasNaoRespondidas && perguntasNaoRespondidas.includes(this.pergunta.sessaoFormularioPerguntaId);

          if(perguntaNaoRespondida){
            return 'pergunta-nao-respondida'
          }else{
            return 'pergunta-respondida'
          }
      }
      return ''
    }
  },
  mounted () {

    switch (this.pergunta.codigoTipoResposta) {
      case TipoResposta.RADIO_BUTTON_VERTICAL:
        this.componentePergunta = RespostaTipoRadioButton
        break
      case TipoResposta.RADIO_BUTTON_HORIZONTAL:
        this.componentePergunta = RespostaTipoRadioButtonHorizontal
        break
      case TipoResposta.INPUT_TEXT_CPF:
        this.componentePergunta = RespostaTipoTextInputCPF
        break
      case TipoResposta.CHECKBOX_VERTICAL:
        this.componentePergunta = RespostaTipoCheckboxVertical
        break
      case TipoResposta.INPUT_TEXT_NUMERO_DECIMAL:
        this.componentePergunta = RespostaTipoTextInputNumeroDecimal;
       break;
      case TipoResposta.INPUT_TEXT_NUMERO_PESO:
        this.componentePergunta = RespostaTipoTextInputPeso;
        break;
      case TipoResposta.INPUT_TEXT_NUMERO_ALTURA:
        this.componentePergunta = RespostaTipoTextInputAltura;
        break;
       case TipoResposta.INPUT_TEXT_NUMERO_INTEIRO:
        this.componentePergunta = RespostaTipoTextInputNumeroInteiro;
        break;
       case TipoResposta.INPUT_SELECT:
         this.componentePergunta = RespostaTipoInputSelect;
        break;
       case TipoResposta.INPUT_SELECT2:
        this.componentePergunta = RespostaTipoInputSelect2;
       break;
      case TipoResposta.INPUT_TEXT_TEXTO_SIMPLES:
        this.componentePergunta = RespostaTipoInputText;
        break;


    }
  },
  props: ['pergunta'],
  created () {
  }
}
</script>

<style>

  .pergunta-respondida{
    border:1px solid green;
    border-radius: 5px;

  }

   .pergunta-nao-respondida{
    border:1px solid red;
    border-radius: 5px;


  }
</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/Pergunta.vue